module.exports = __webpack_public_path__ + "img/ps-4.c66d72ca.jpg";